import DynamicMultiSelectInput from 'components/forms/inputs/rhf-inputs/DynamicMultiSelectInput.tsx';
import ContactDynamicMultiSelectInput from 'components/party/ContactDynamicMultiSelectInput';
import { useInRecordSection } from 'components/section-edit/SectionEdit';
import { useLazyGetEmployeesListWithFiltersQuery } from 'store/api/employees';
import { TaskFormState } from './useTaskForm';

/** Assignees: who the task is assigned to and by. */
export const AssigneesFields = ({ form }: { form: TaskFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { updateEventInvitees } = form;
    // On the record page each field is a cell of the card's grid, where the read view has its row.
    const inSection = useInRecordSection();

    return (
        <div className={inSection ? 'contents' : 'flex w-full flex-wrap gap-2'}>
            <div className={inSection ? 'contents' : 'flex-1 pt-2'}>
                <DynamicMultiSelectInput
                    onChange={updateEventInvitees}
                    setValue={setValue}
                    control={control}
                    label="tasks.form.assigned-to"
                    placeholder="tasks.form.assigned-to"
                    name="assignedToEmployees"
                    paginated={{
                        fetch: useLazyGetEmployeesListWithFiltersQuery,
                        searchField: 'fullName',
                    }}
                    getOptionLabel="name"
                    getOptionIdentifier="id"
                    required
                />
            </div>
            <div className={inSection ? 'contents' : 'flex-1 pt-2'}>
                <ContactDynamicMultiSelectInput
                    setValue={setValue}
                    control={control}
                    label="tasks.form.assigned-by"
                    placeholder="tasks.form.assigned-by"
                    name="assignedByEmployees"
                    paginated={{
                        fetch: useLazyGetEmployeesListWithFiltersQuery,
                        searchField: 'fullName',
                    }}
                    required
                />
            </div>
        </div>
    );
};
